import ComponentHelper from '../../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import _ from 'lodash';
import './add-tenant-modal.css';
import Dropdown from '../../../components/dropdown/Dropdown';
import AuthService from '../../../services/AuthService';
import RESTService from '../../../services/RESTService';
import RoutingService from '../../../services/RoutingService';
const auth = new AuthService();
const connect = new RESTService();
const RS = new RoutingService();

class AddTenantModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.autoBindAll(this);
		this.setInitialData(props);
	}

	setInitialData(props) {
		this.data = {
			title: 'Add user to tenants with this role.',
			selectedTenants: [],
			tenants: props.tenants,
			role: props.role,
			user: props.user
		};
	}

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	onAddTenants() {
		let user = this.data.user;
		let tenantRoles = user.tenantRoles || {};
		_.forEach(this.data.selectedTenants, tenant => {
			tenantRoles[tenant.label] = [this.data.role];
		});
		user.tenantRoles = tenantRoles;
		connect
			.updateUser(user)
			.then(() => {
				RS.showSuccess();
				this.props.onComplete();
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	onTenantsChange(newVal) {
		this.observe(() => {
			this.data.selectedTenants = newVal;
		});
	}

	getTenants() {
		let options = [];
		let validTenants = auth.getAvailableTenants();
		let current = this.data.user ? Object.keys(this.data.user.tenantRoles) : [];
		_.forEach(this.data.tenants, t => {
			if (current.indexOf(t.name) < 0 && (auth.hasPlatformRole() || validTenants.indexOf(t.name) >= 0)) {
				options.push({ label: t.name, value: t._id });
			}
		});
		return options;
	}

	render() {
		let { isOpen } = this.props;
		let { title, selectedTenants } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="add-tenant-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				<div className="modal-body">
					<Dropdown
						className="w-100"
						label="Tenants"
						value={selectedTenants}
						placeholder="Select tenants"
						tagPicker={true}
						handleChange={this.onTenantsChange}
						name="tenantPicker"
						options={this.getTenants()}
					/>
				</div>
				<div className="btn-ctn">
					<button className="btn cancel-btn" onClick={this.props.onCancel}>
						Cancel
					</button>
					<button className="btn primary" onClick={this.onAddTenants}>
						Add
					</button>
				</div>
			</Modal>
		);
	}
}
export default AddTenantModal;



// WEBPACK FOOTER //
// ./src/views/user-management/add-tenant-modal/AddTenantModal.js